import React, { useRef, useState, useEffect } from 'react'
import { SketchPad } from './SketchPad'
import { Button } from 'carbon-components-react'
import { Close, Maximize, Minimize } from '@carbon/icons-react'
import { CaretUp, CaretDown } from '@carbon/icons-react'
import { KnovaText } from '../BasicUIComponents/KnovaText'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

function HeaderModal(props) {
  const {
    secModalActiveName,
    sketchPadInitial,
    sketchPadDataArray,
    textAreaData,
    completed,
    isActive
  } = props
  const {
    onCloseClick,
    onSketchDataCapture,
    onSketchDisplayed,
    onTextAreaDataCapture
  } = props
  const [currentSketchIndex, setCurrentSketchIndex] = useState(0)
  const [sketchDataArray, setSketchDataArray] = useState([
    { strokeData: [], strokeActions: [] }
  ])
  const [isSketchAreaChanged, setIsSketchAreaChanged] = useState(false)

  const [richTextValue, setRichTextValue] = useState('')

  useEffect(() => {
    if (sketchPadInitial) {
      if (secModalActiveName === 'sketchPad') {
        if (sketchPadDataArray.length > 0) {
          setSketchDataArray(sketchPadDataArray)
        }
      } else if (secModalActiveName === 'textArea') {
        if (textAreaData !== '') {
          setRichTextValue(textAreaData)
        } else {
          setRichTextValue('')
        }
      }
    }
  }, [sketchPadInitial])

  function handleSketchData(strokeArrayData, strokeActionsData) {
    let sketchDataArrayCopy = [...sketchDataArray]
    sketchDataArrayCopy[currentSketchIndex] = {
      strokeData: strokeArrayData,
      strokeActions: strokeActionsData
    }
    if (currentSketchIndex === sketchDataArray.length - 1) {
      sketchDataArrayCopy[currentSketchIndex + 1] = {
        strokeData: [],
        strokeActions: []
      }
    }
    setSketchDataArray(sketchDataArrayCopy)
    onSketchDataCapture(sketchDataArrayCopy)
  }

  function sketchNavigationClick(clickType) {
    setIsSketchAreaChanged(true)
    if (clickType === 'next') {
      if (currentSketchIndex < sketchDataArray.length - 1) {
        setCurrentSketchIndex((sketchDataIndex) => sketchDataIndex + 1)
      }
    } else {
      if (currentSketchIndex > 0) {
        setCurrentSketchIndex((sketchDataIndex) => sketchDataIndex - 1)
      }
    }

    setTimeout(() => {
      setIsSketchAreaChanged(false)
    }, 100)
  }

  function renderSketchArea() {
    return (
      <div className='sketch-area-cont'>
        <div className='multiple-sketch-area-cont'>
          {sketchDataArray.map((sketchData, sketchDataIndex) => {
            return (
              <div
                className='sketch-pad-area'
                style={{
                  pointerEvents: completed === 0 && isActive ? false : true
                }}
              >
                <SketchPad
                  // canvasDimension={canvasAreaDimensions}
                  currentStrokeData={sketchDataArray[currentSketchIndex]}
                  currentSketchIndex={currentSketchIndex}
                  isSketchAreaChanged={isSketchAreaChanged}
                  sketchPadInitial={sketchPadInitial}
                  isSideMenu={false}
                  onStrokeDataCapture={(strokeArrayData, strokeActionsData) => {
                    handleSketchData(strokeArrayData, strokeActionsData)
                  }}
                  onSketchDisplayed={onSketchDisplayed}
                />
              </div>
            )
          })}
        </div>
        <div className='sketch-scroll-area-cont'>
          <div
            className='sketch-scroll-button'
            onClick={() => {
              sketchNavigationClick('previous')
            }}
          >
            <CaretUp className='sketch-scroll-icon'></CaretUp>
          </div>
          <div className='sketch-scroll-area'>
            {sketchDataArray.map((sketchData, sketchDataIndex) => {
              let scrollHeight = 100 / sketchDataArray.length
              return (
                <div
                  className={
                    sketchDataIndex === currentSketchIndex
                      ? 'sketch-scroll-bar sketch-scroll-bar-active'
                      : 'sketch-scroll-bar'
                  }
                  style={{ height: scrollHeight + '%' }}
                />
              )
            })}
          </div>
          <div
            className='sketch-scroll-button'
            onClick={() => {
              sketchNavigationClick('next')
            }}
          >
            <CaretDown className='sketch-scroll-icon'></CaretDown>
          </div>
        </div>
      </div>
    )
  }

  //RTE modal functions
  let modules = {
    toolbar: [
      // [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' }
      ],
      ['link', 'image']
      // ["clean"],
    ]
  }
  let modulesEmpty = {
    toolbar: false
  }

  let formats = [
    // 'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image'
  ]

  function onEditorValueChange(editorValue) {
    setRichTextValue(editorValue)
    onTextAreaDataCapture(editorValue)
  }

  function renderRTEArea() {
    return (
      <div className='sc-richtext-cont'>
        <ReactQuill
          id={1}
          theme='snow'
          modules={modules}
          formats={formats}
          readOnly={completed === 0 && isActive ? false : true}
          onChange={(value) => {
            onEditorValueChange(value)
          }}
          value={richTextValue}
          placeholder='Text goes here'
        />
      </div>
    )
  }

  return (
    <div className='sec-header-modal-container'>
      <div className='modal-header-cont'>
        <div className='heading-text-cont'>
          <KnovaText
            text={
              secModalActiveName === 'sketchPad' ? 'Sketch pad' : 'Text area'
            }
            textColor='#FFFFFF'
            textMargin='0px'
          />
        </div>
        <div className='heading-button-cont'>
          <Button
            className='heading-icon'
            hasIconOnly
            iconDescription='Close'
            renderIcon={Close}
            tooltipAlignment='center'
            tooltipPosition='bottom'
            onClick={() => {
              onCloseClick()
              // if (!displayWalkThrough) {
              //   onCloseClick()
              // }
            }}
          />
        </div>
      </div>
      <div className='modal-body-cont'>
        {secModalActiveName === 'sketchPad'
          ? renderSketchArea()
          : renderRTEArea()}
      </div>
    </div>
  )
}
export { HeaderModal }
